<template>
  <a-table
    id="tableDataTabs"
    bordered
    :columns="tableData.columns"
    :data-source="tableData.data"
    :pagination="tableData.pagination"
    @change="handleTableChange"
  >
    <template slot="actions" slot-scope="text, record">
      <a href="javascript:;" @click.stop="() => handleDetail(record)">详情</a>
    </template>
  </a-table>
</template>
<script>
import { getListByAssetNumber } from '@/api/assetLedger'

export default {
  props: {
    model: Object,
    subcompanyid: Number || String
  },
  data () {
    return {
      tableData: {
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 50
          },
          {
            title: '设备名称',
            dataIndex: 'name',
            align: 'left'
          },
          {
            title: '设备编号',
            dataIndex: 'equipmentNumber',
            align: 'left'
          },
          {
            title: '内部编号',
            dataIndex: 'interiorCode',
            align: 'left'
          },
          {
            title: '设备类别',
            dataIndex: 'equipmentTypeName',
            align: 'left'
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            align: 'center'
          }
        ],
        data: [],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
          pageSizeOptions: ['10', '20', '30', '40', '9999'],
          showSizeChanger: true,
          showQuickJumper: true
        }
      },
      analogData: []
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      const data = {
        assetNumber: this.model.assetNumber,
        subcompanycode: this.model.bukrs,
        pageNum: this.tableData.pagination.pageNum,
        pageSize: this.tableData.pagination.pageSize
      }
      getListByAssetNumber(data).then(res => {
        if (res.status === 0) {
          for (const listElement of res.data.list) {
            delete listElement.children
          }
          this.tableData.data = res.data.list
          this.tableData.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    handleTableChange (pagination) {
      this.tableData.pagination.pageSize = pagination.pageSize
      this.tableData.pagination.pageNum = pagination.current
      this.tableData.pagination.current = pagination.current
      this.getTableData()
    },
    handleDetail (row) {
      if (!row.equipmentNumber) {
        this.$message.error('当前设备没有设备编号，无法跳转查看')
        return
      }
      const newpage = this.$router.resolve({
        path: '/equipmentLedger2/equipmentLedger'
      })
      // 打开新的标签页跳转
      window.open(newpage.href, '_blank')
      // this.$router.push({
      //   path: '/equipmentLedger2/equipmentLedger'
      // })
      localStorage.setItem('equipmentNumber', row.equipmentNumber)
    }
  }
}
</script>

<style lang="less" scoped>
.table{
  margin-left: -1px;
  margin-right: -1px;
  // /deep/.ant-table-pagination.ant-pagination {
  //   margin-bottom: 10px !important;
  //   margin-right: 10px !important;
  // }

  /deep/.ant-table-thead > tr > th {
    background: #E7F4FF !important;
    background: rgba(8, 64, 159, 0.1);
  }
  /deep/.ant-table-tbody > tr > td {
    padding: 10px;
  }
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
